import { useMutation } from '@tanstack/react-query';
import { patch } from '@truefit/http-utils';

interface InstanceReservationRequest {
  user: number;
  operation: 'reserve' | 'unreserve';
}

interface InstanceReservationResponse {
  success: boolean;
  session?: Session;
  message?: string;
}

interface InstanceReservationError {
  message: string;
  status?: number;
}

const useInstanceReservationMutation = () =>
  useMutation<InstanceReservationResponse, InstanceReservationError, InstanceReservationRequest>({
    mutationFn: async (request: InstanceReservationRequest) => {
      try {
        const response = await patch<InstanceReservationResponse>(
          '/v1.0/internals/mgmt/instance/user',
          request
        );

        if (!response || !(response.status === 200)) {
          throw new Error(response?.message || `Failed to ${request.operation} instance for user`);
        }

        return response;
      } catch (error) {
        console.error(`Error during instance reservation mutation:`, error);
        // Enhance error object with type checking
        const err = error as Error;
        throw {
          message: err.message || `Failed to ${request.operation} instance for user`,
          status: (error as any)?.status || 500
        };
      }
    },
    gcTime: 0,
    retry: (failureCount, error) => {
      console.error(error)
      // Only retry if it's not a 400-level error
      return failureCount < 3 && !(error.status >= 400 && error.status < 500);
    }
  });

export default useInstanceReservationMutation;